import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    DropdownData,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { TransaccionModel } from 'src/app/models/reto/transaccion.model';

/** Form used by the transactions file-generation dialog. */
export class TransaccionesGenerateFormDefinition {
  public readonly formFields: Form<TransaccionModel>;

  constructor(private readonly ropoResponsable: DropdownData<string>) {
    this.formFields = {
      name: 'transacciones-generate',
      header: '',
      type: FormType.GENERATION,
      sections: [this.createSection()],
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private createSection(): FormSection<TransaccionModel> {
    return {
      name: '',
      fields: [
        this.field('fecha_inicio', 'Fecha inicio', 1, InputType.CALENDAR),
        this.field('fecha_fin', 'Fecha fin', 2, InputType.CALENDAR),
        this.dropdownField('ropo_responsable', 'Ropo responsable', 3),
      ],
      width: 12,
      isVisible: true,
      order: 1,
    };
  }

  private field(name: string, label: string, order: number, inputType: InputType): FormField<TransaccionModel> {
    return {
      name,
      label,
      input: {
        type: inputType,
        isEditable: true,
      },
      width: 6,
      conditions: this.conditions(),
      order,
    };
  }

  private dropdownField(name: string, label: string, order: number): FormField<TransaccionModel> {
    return {
      name,
      label,
      input: {
        type: InputType.DROPDOWN_SEARCH,
        isEditable: true,
        data: this.ropoResponsable,
      },
      width: 6,
      conditions: this.conditions(),
      order,
    };
  }

  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }
}
